module.exports = __webpack_public_path__ + "static/img/Round-01-2013.6075226.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-01-2013.jpg
// module id = Cdip
// module chunks = 0